var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.833 10.833c.584 0 1.142.109 1.667.292V7.5l-5-5H4.167A1.66 1.66 0 0 0 2.5 4.167v11.666A1.666 1.666 0 0 0 4.167 17.5h6.958a5.041 5.041 0 0 1-.292-1.667c0-2.758 2.242-5 5-5ZM11.667 3.75l4.583 4.583h-4.583V3.75Zm7.5 11.25v1.667h-2.5v2.5H15v-2.5h-2.5V15H15v-2.5h1.667V15h2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.e491775797098cd7984529cbd91361cf.svg";
export { ForwardRef as ReactComponent };